import {RelationType} from "../relationType";
import Organization from "../organization";
import PublishedObjectModel from "../objectModels/publishedObjectModel";
import DetailView from "./detailView";
import DetailViewContentElement from "./elements/detailViewContentElement";

export default class PublishedDetailView extends DetailView {
  u_at: string;
  c_at: string;
  detail_view_id: string;
  object_model_id:string;
  title: string;
  author: any;
  organization: Organization;
  published_object_model: PublishedObjectModel;
  available_action_client_ids: Array<string>;

  get objectModel(){
    return this.published_object_model
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      content_elements: {type: DetailViewContentElement, relationType: RelationType.dictionary},
      published_object_model: {type: PublishedObjectModel, relationType: RelationType.singleObject},
    };
  }
}